import { Locale } from "@redotech/crdb-enums/common/locale";
import { TRANSLATION_SOURCES } from "@redotech/redo-customer-portal-common/translation-source";
import * as z from "zod";

export const getPortalCustomizationTranslations = {
  name: "getPortalCustomizationTranslations" as const,
  input: z.object({ elementIds: z.array(z.uuid()).max(200).optional() }),
  output: z.object({
    translations: z.array(
      z.object({
        elementId: z.string(),
        field: z.string(),
        language: z.enum(Locale),
        text: z.string(),
        source: z.enum(TRANSLATION_SOURCES),
        sourceText: z.string().nullable(),
      }),
    ),
  }),
};
